import { lazy } from 'react';

const ChangeRequestModal = lazy(
  () => import('modules/ProfileManagement/modals/ChangeRequestModal'),
);

export default {
  CHANGE_REQUEST_MODAL: ChangeRequestModal,
};
